import {
  AccessPointType_enum,
  PermissionKey_enum,
  Role_bool_exp,
  RoleKey_enum,
} from '../../../graphql/hasura/generated';

export function getApplicableRolesByAccessPoint(
  accessPointId: string,
  type: AccessPointType_enum,
): Role_bool_exp {
  const excludedRoleKeys: RoleKey_enum[] = [];
  const excludedRolesExp: Role_bool_exp[] = [];

  if (type !== AccessPointType_enum.AMENITY) {
    excludedRoleKeys.push(RoleKey_enum.AMENITY_ACCESS);
  }

  if (type !== AccessPointType_enum.RESERVATION_ONLY) {
    excludedRoleKeys.push(RoleKey_enum.RESERVATION);
  }

  if (excludedRoleKeys.length) {
    excludedRolesExp.push({
      _or: [
        {
          key: { _is_null: true },
        },
        {
          key: { _nin: excludedRoleKeys },
        },
      ],
    });
  }

  return {
    rolePermissions: {
      permission: {
        key: { _eq: PermissionKey_enum.AccessPoint_Unlock },
      },
    },
    // Default roles and custom roles
    _or: [
      {
        organizationId: { _is_null: true },
      },
      {
        organization: {
          properties: {
            accessPoints: {
              accessPointId: { _eq: accessPointId },
            },
          },
        },
      },
    ],
    _and: excludedRolesExp,
  };
}
